/* ==================================================
 *  Search
 * ==================================================*/

(function () {

  'use strict';

  $(document).on('keyup', 'input[type="search"][name="term"]', function (ev) {
    var $this = $(this);
    var $parent = $this.parent();

    if ($this.val().length === 0) {
      return $parent.removeClass('in');
    }
    return $parent.addClass('in');
  });

  $('input[type="search"][name="term"]').trigger('keyup');

  $(document).on('click', '[data-search-clear]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var $parent = $this.parent();
    var $target = $parent.find('input[type="search"]');
    var $form = $this.parents('form');

    $target.val('');

    $form.trigger('search.cleared');
  });

})();
